import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import AnimatedHeroBackground from "./components/AnimatedHeroBackground";
import Dashboard from "./components/dashboard/ClientDashboard";
import useToken from "./services/useToken";
import Header from "./components/Header";
import MobileHeader from "./components/MobileHeader"
import Order from "./components/order/Order";
import BottleOrder from "./components/bottleorders/bottleorder";
import BottleOrdersTable from "./components/bottleorders/BottleOrdersTable"
import Invoice from "./components/invoice/Invoice";
import InvoicesTable from "./components/invoice/InvoicesTable"
import AddWaterProfile from "./components/water-profiles/AddWaterProfile";
import WaterProfilesTable from "./components/water-profiles/WaterProfilesTable";
import WaterProfileComparison from "./components/water-profile-comparison/WaterProfileComparison";
import { useEffect, useState } from "react";
import MultiClientDashboard from "./components/dashboard/MultiClientDashboard";
import useGaTracker from "./usGaTracker";
import LogRocket from "logrocket";
import Client from "./components/client/Client";
import LabOrders from "./components/order/LabOrders"
import { NotificationContainer } from "react-notifications";
import { isMobile } from "react-device-detect";

LogRocket.init("ghozmy/vlp-client");

const RenderBody = ({ logout, token }) => {
  const [selectedClient, setSelectedClient] = useState();

  useEffect(() => {
    if (token.accountNumbers.length === 0) {
      setSelectedClient(token.accountNumber);
    }
    // if (token.accountNumbers.length > 0) {
    // 	setSelectedClient(token.accountNumbers[0]);
    // }
  }, [token]);

  return (
    <>
      <NotificationContainer leaveTimeout={3000} />
      <div className="app-shell">

        {isMobile ? <MobileHeader
          logout={logout}
          accountNumber={selectedClient}
          isMultiClient={token.accountNumbers.length > 0}
          clientType={token.clientType}
          clearClient={() => {
            setSelectedClient();
            window.location.href = window.location.origin;
          }}
        /> : <Header
          logout={logout}
          accountNumber={selectedClient}
          isMultiClient={token.accountNumbers.length > 0}
          clientType={token.clientType}
          clientName={token.name}
          clearClient={() => {
            setSelectedClient();
            window.location.href = window.location.origin;
          }}
        /> }

        <div>
          <div>
            <Switch>
              {useGaTracker()}
              <Redirect exact from="/" to="dashboard" />
              <Route exact path="/dashboard">
                {token.accountNumbers.length > 0 && !selectedClient ? (
                  <MultiClientDashboard
                    logout={logout}
                    token={token}
                    setAccount={setSelectedClient}
                  />
                ) : (
                  <Dashboard
                    logout={logout}
                    accountNumber={selectedClient}
                    token={token}
                  />
                )}
              </Route>
              <Route exact path="/dashboard/:acc">
                <Dashboard
                  logout={logout}
                  accountNumber={selectedClient}
                  token={token}
                />
              </Route>
              <Route exact path="/invoices">
                <InvoicesTable
                  logout={logout}
                  accountNumber={selectedClient}
                  token={token}
                />
              </Route>
              <Route exact path="/bottle-orders">
                <BottleOrdersTable
                  logout={logout}
                  accountNumber={selectedClient}
                  token={token}
                />
              </Route>

              <Route exact path="/lab-orders">
                <LabOrders
                  logout={logout}
                  accountNumber={selectedClient}
                  token={token}
                />
              </Route>



              <Route path="/order/:orderNumber" component={Order}></Route>
              <Route exact path="/client">
                <Client accountNumber={selectedClient} />
              </Route>


              <Route exact path="/water-profiles">
                <WaterProfilesTable accountNumber={selectedClient} />
              </Route>
              <Route exact path="/water-profile-comparison">
                <WaterProfileComparison accountNumber={selectedClient} />
              </Route>
                
              <Route exact path="/water-profiles/:id">
                <AddWaterProfile accountNumber={selectedClient} />
              </Route>
              <Route exact path="/water-profiles/add">
                <AddWaterProfile accountNumber={selectedClient} />
              </Route>
              


              <Route path="/invoice/:invoiceNumber" component={Invoice}></Route>
              <Route
                path="/bottleorder/:orderNumber"
                component={BottleOrder}
              ></Route>
            </Switch>
          </div>
        </div>
      </div>
    </>
  );
};

function App() {
  const { token, setToken, logout } = useToken();

  if (!token) {
    return <AnimatedHeroBackground setToken={setToken} />;
  }

  const now = Date.now().valueOf();
  const tokeExp = token.expiration && Date.parse(token.expiration);

  return (
    <>
      {tokeExp < now ? (
        <AnimatedHeroBackground setToken={setToken} />
      ) : (
        <RenderBody logout={logout} token={token} />
      )}
    </>
  );
}

export default App;
